import useContent from './useContent';
import { merge } from 'lodash-es';
import themePresets from '../lib/themePresets';
import defaults from '../themes/theme-default.yml';
import { provide, inject, InjectionKey, computed, ref, watchEffect } from 'vue';

const key = Symbol('theme') as InjectionKey<Ref<ThemeOptions>>;

// let b = 0;
// let p = 0;

const computeBaseTheme = ({ content, themePresets }) => {
  const name = content.value?.compiled.course.theme;
  const presets = themePresets.value?.[name];
  const settings = content.value?.compiled.course['theme-options'];

  // console.log('base', ++b);

  return merge({}, defaults, presets, settings);
};

const content = ref();
const baseTheme = ref();

watchEffect(() => {
  if (content.value && themePresets.value) {
    baseTheme.value = computeBaseTheme({ content, themePresets });
  }
});

const useBaseTheme = () => {
  if (!content.value) content.value = useContent();

  return baseTheme;
};

export const useTheme = (toMerge: ThemeOptions = {}) => {
  toMerge = toMerge || {};
  const baseTheme = useBaseTheme();
  const filteredOptions = {};

  // console.log('provide', ++p);

  Object.keys(defaults).forEach(k => {
    filteredOptions[k] = toMerge[k];
  });

  const injected = inject(key, ref({}));

  const theme = computed<ThemeOptions>(() =>
    merge({}, baseTheme?.value, injected?.value, filteredOptions)
  );

  provide(key, theme);

  return theme;
};

export default useTheme;

async function hotUpdateThemePreset() {
  if (import.meta.hot) {
    const loadYaml = (await import('js-yaml')).load;
    await new Promise(r => setTimeout(r, 100));

    const loadRaw = async (path: string) => {
      try {
        return (await fetch(path)).text();
      } catch (e) {
        return null;
      }
    };

    const theme = document.getElementById('app-content')?.dataset.theme;
    const raw = await loadRaw(`/src/themes/theme-${theme}.yml`);

    if (raw) {
      themePresets.value = { ...themePresets.value, [theme]: loadYaml(raw) };
    }
  }
}

if (import.meta.hot) {
  import.meta.hot.accept();
  import.meta.hot.on('vite:beforeUpdate', hotUpdateThemePreset);
}
